import script from "./ProfileCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileCompany.vue?vue&type=script&setup=true&lang=js"

import "./ProfileCompany.vue?vue&type=style&index=0&id=1090fe60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1090fe60"]])

export default __exports__